import {CapTextureDto} from "./cap-texture-dto";

export enum CapType {
  COMMON = "COMMON",
  RARE = "RARE",
  LEGENDARY = "LEGENDARY",
}

export enum CapCategory {
  ALIENS = "ALIENS",
  INVENTORS = "INVENTORS",
  CHAOS = "CHAOS",
}

export interface CapDto {
  id: string;
  name: string;
  texture: CapTextureDto;
  type: CapType;
  category: CapCategory;
  collection: string;
}